import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import GridViewIcon from '@mui/icons-material/GridView';
import { Box, Card, Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ComponentRoleAuto from 'src/components/ComponentRoleAuto';
import MenuRoleAutho from 'src/components/MenuRoleAutho';
import UserBasedComponentAuth from 'src/components/UserBasedComponentAuth';
import UserRoleAutho from 'src/components/UserRoleAutho';
import { ORANGE, DARK } from 'src/components/dynamicCatalogStyles';

// key adres çubuğunda (?sekme=) kullanılır
const TABS = [
  { key: 'kullanici-rol', label: 'Kullanıcı Rol Yetkilendirme', icon: SupervisedUserCircleIcon, component: UserRoleAutho },
  { key: 'menu', label: 'Menü Yetkilendirme', icon: AutoAwesomeMotionIcon, component: MenuRoleAutho },
  { key: 'islem', label: 'İşlem Yetkilendirme', icon: SwipeRightIcon, component: ComponentRoleAuto },
  { key: 'kullanici-islem', label: 'Kullanıcı Bazlı İşlem Yetkilendirme', icon: GridViewIcon, component: UserBasedComponentAuth }
];
const QUERY_KEY = 'sekme';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%',
    padding: '16px 24px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '12px'
    }
  },
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    backgroundColor: '#f5f5f5',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  tabs: {
    minHeight: '48px',
    '& .MuiTab-root': {
      minHeight: '48px',
      padding: '6px 16px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      color: '#607d8b',
      whiteSpace: 'nowrap',
      '& .MuiSvgIcon-root': { fontSize: '18px', marginRight: '6px' }
    },
    '& .MuiTab-root:hover': {
      color: DARK
    },
    '& .MuiTab-root.Mui-selected': {
      color: ORANGE
    }
  }
}));

function Authorization() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const requested = new URLSearchParams(location.search).get(QUERY_KEY);
  const tab = TABS.find((t) => t.key === requested) || TABS[0];
  const TabComponent = tab.component;

  const openTab = (key) => {
    if (key === tab.key) return;
    const params = new URLSearchParams(location.search);
    params.set(QUERY_KEY, key);
    history.replace({ pathname: location.pathname, search: `?${params.toString()}` });
  };

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <Tabs
          value={tab.key}
          onChange={(e, v) => openTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          className={classes.tabs}
          TabIndicatorProps={{ style: { background: ORANGE, height: 3, borderRadius: '3px 3px 0 0' } }}
        >
          {TABS.map((t) => {
            const Icon = t.icon;
            return <Tab key={t.key} value={t.key} iconPosition="start" icon={<Icon />} label={t.label} />;
          })}
        </Tabs>
      </Card>
      <Box sx={{ pt: 2 }}>
        <TabComponent key={tab.key} />
      </Box>
    </Box>
  );
}

export default Authorization;
